import React from 'react'
import { useTranslation } from 'react-i18next'
import AccordionItem from '../../components/common/AccordionItem/AccordionItem'
import RoundsRateData from '../../types/roundsRate/RoundsRateData'
import ProfileAttributeTableFragmentGenerator from '../../utils/TableGenerator/ProfileAttributeTableFragmentGenerator'
import { getCurrentCampaignYear } from '../../utils/previousIncomeAttributes'

interface RoundsRateTabProps {
    courses: number[],
    data: Record<string, string | number | null>,
    keys: string[],
    valueChangeHandler: (value: string | number | null | undefined, name: string) => void,
    previousCampaign?: boolean,
    year?: string
}

function RoundsRateTab(props: RoundsRateTabProps) {
    const { courses, data, keys, valueChangeHandler } = props
    const { t } = useTranslation('rounds_rate')
    const isInternalUser = sessionStorage.getItem("isInternalUser") ? true : false;
    const currentCampaignYear = getCurrentCampaignYear()

    return (
        <>
            {data && courses.map((e, i) => {
                return <AccordionItem
                    header={t("course" + (i + 1)) + (isInternalUser ? " " + (props.year ? props.year : String(currentCampaignYear)) : "")}
                    key={"roundsTableHeader" + e}
                    itemKey={"roundsTableHeader" + e}
                    headingLevel={2}
                >
                    <table className="table-with-border pie-table accordion-content">
                        <thead>
                            <tr>
                                <th id="attribute-label" scope="col"></th>
                                <th id="attribute-value" scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {keys.map((key) => {
                                if (["courseName" + e].includes(key)) {
                                    return <ProfileAttributeTableFragmentGenerator
                                        key={key}
                                        name={key}
                                        fieldType='string'
                                        data={data[key as keyof RoundsRateData] as number}
                                        translationFile='rounds_rate'
                                        stringValueChangeHandler={valueChangeHandler}
                                        isRequiredField={i === 0}
                                        symbol={""}
                                        hideTooltip={true} />
                                } else if (["numberOfHole" + e].includes(key)) {
                                    return <ProfileAttributeTableFragmentGenerator
                                        key={key}
                                        name={key}
                                        fieldType='integer'
                                        data={data[key as keyof RoundsRateData] as number}
                                        translationFile='rounds_rate'
                                        valueChangeHandler={valueChangeHandler}
                                        isRequiredField={i === 0}
                                        symbol={""}
                                        hideTooltip={true} />
                                } else if (["primeRate" + e].includes(key)) {
                                    return <ProfileAttributeTableFragmentGenerator
                                        key={key}
                                        name={key}
                                        fieldType='decimal'
                                        data={data[key as keyof RoundsRateData] as number}
                                        translationFile='rounds_rate'
                                        valueChangeHandler={valueChangeHandler}
                                        isRequiredField={i === 0}
                                        symbol={""} />
                                } else if (["regularRound" + e, "memberRound" + e, "complimentaryRound" + e].includes(key)) {
                                    return <ProfileAttributeTableFragmentGenerator
                                        key={key}
                                        name={key}
                                        fieldType='integer'
                                        data={data[key as keyof RoundsRateData] as number}
                                        translationFile='rounds_rate'
                                        valueChangeHandler={valueChangeHandler}
                                        isRequiredField={i === 0}
                                        symbol={""}
                                        hideTooltip={false} />
                                } else
                                    return null
                            })}
                        </tbody>
                    </table>
                </AccordionItem>
            })}
        </>
    )
}

export default RoundsRateTab